import CategorySortCard from 'components/cards/CategorySortCard'
import { CategoryTopic } from 'interface/CategoryTopic';
import React from 'react'
import styles from 'styles/layout/ReportCategoryDisplaySection.module.sass'
import CategoryReportsDisplaySection from './CategoryReportsDisplaySection';

/**
 * Props for the ReportCategoryDisplaySection component.
 *
 * @param allReports - All available reports.
 * @param filteredReports - The currently filtered reports.
 * @param setFilteredReports - Function to update the filtered reports.
 */
interface ReportCategoryDisplaySectionProps {
    allReports: CategoryTopic[];
    filteredReports: CategoryTopic[];
    setFilteredReports: React.Dispatch<React.SetStateAction<CategoryTopic[]>>;
}

/**
 * ReportCategoryDisplaySection component displays a section for report categories.
 *
 * @param allReports - All available reports.
 * @param filteredReports - The currently filtered reports.
 * @param setFilteredReports - Function to update the filtered reports.
 * 
 * @returns The rendered ReportCategoryDisplaySection component.
 * 
 * @example
 * <ReportCategoryDisplaySection allReports={allReports} filteredReports={filteredReports} setFilteredReports={setFilteredReports} />
 */
const ReportCategoryDisplaySection: React.FC<ReportCategoryDisplaySectionProps> = ({ allReports, filteredReports, setFilteredReports }) => {
    return (
        <section className={styles['report-category-display-section']}>
            <CategorySortCard reports={allReports} setFilteredReports={setFilteredReports} />
            <CategoryReportsDisplaySection reports={filteredReports} />
        </section>
    )
}

export default ReportCategoryDisplaySection